import { NAME } from "./constants";
import innerRoutes from "./innerRoutes";

import { ElCommunicationC360EmailTab, ElCommunicationSuccessTab, ElCommunicationTab } from "./tabs";

export { default as CampaignPage } from "app/pages/campaign/Container";

// The success page is intentionally implemented as a separate page
// to prevent multiple campaign loading / submissions on browser reload.
export const CampaignTabs = {
    ElCommunicationTab,
    ElCommunicationC360EmailTab,
    ElCommunicationSuccessTab,
};

export default {
    NAME,
    innerRoutes,
};
